import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'


import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'


import * as PlaybookActions from 'app/modules/playbook/actions'
import * as OrgActions from 'app/modules/org/actions'
import * as PropertySelectors from 'app/modules/user/properties/selectors'
import ExtensionInviteModal from './component'

const usersWithExtension = PropertySelectors.makeUsersWithProperty('extensionInstalled')

const mapStateToProps = state => ({
  usersWithExtension: usersWithExtension(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideExtensionInviteModal: PlaybookActions.hideExtensionInviteModal,
      sendInvitationsViaEmail: OrgActions.sendInvitationsViaEmail,
      sendInvitationsViaSlack: OrgActions.sendInvitationsViaSlack,
    },
    dispatch,
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onCloseClick: props => () => {
      const { actions: { hideExtensionInviteModal }} = props
      hideExtensionInviteModal()
    },
    sendInvitationsViaEmail: props => (emails, scopes) => {
      const { actions: { sendInvitationsViaEmail }} = props
      const invitations = {
        invitations: _.map(emails, email =>
          ({ user: { email, scopes }, properties: { extensionInvited: true }}))
      }
      sendInvitationsViaEmail(invitations)
    },
    sendInvitationsViaSlack: props => (users, scopes) => {
      const { actions: { sendInvitationsViaSlack }} = props
      const invitations = {
        invitations: _.map(users, user =>
          ({ user: { email: user.email, slackUserId: user.slackUserId, scopes }, properties: { extensionInvited: true }}))
      }
      sendInvitationsViaSlack(invitations)
    },

  }),
)(ExtensionInviteModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ExtensionInviteModal/index.js